export default __webpack_public_path__ + "static/media/grunge_border_full.a1532a35.png";